// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 931) return "static/chunks/931.bcd2b73afa2d225e.js";
	if (chunkId === 1908) return "static/chunks/1908.55ad7e2010b55c99.js";
	if (chunkId === 3011) return "static/chunks/3011.27f1d136f101e505.js";
	if (chunkId === 7639) return "static/chunks/7639.d69b4eb2a8953a18.js";
	if (chunkId === 9031) return "static/chunks/9031.cadf8762f39e71ac.js";
	if (chunkId === 5015) return "static/chunks/5015.2d3fc7aaa4719664.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"379":"afa00656e8419595","1107":"3e31614fcfa97108","1307":"0a88f60c7533b613","4281":"863019a69bd917d6","6812":"598f3f3a6fa5090f","6946":"7c053d05990ffcf2","7345":"0aa38287071b5c35"}[chunkId] + ".js";
};